export default __webpack_public_path__ + "static/ELDP-S3-LG-XL-ca553b1fdb88af7fa03b91cf1d4d47e9.webp";